let PROD_BASE_URL = "https://api.tor.digital/v1";
let PROD_BASE_URL_IMAGE = "https://api.tor.digital/v1";

let DEV_BASE_URL = "https://dev.tor.digital/v1";
let DEV_BASE_URL_IMAGE = "https://dev.tor.digital/v1";

let LOCAL_BASE_URL = "http://localhost:3100/v1";
let LOCAL_BASE_URL_IMAGE = "http://localhost:3100/v1";

// PROD
export const BASE_URL = PROD_BASE_URL;
export const IMAGE_BASE_URL = PROD_BASE_URL_IMAGE;
